import React, {useState, useEffect} from 'react'
import './DisplayIndividualPerson.css'

// Other Imports:
import { db } from '../utils/User/include/Authorize';
import { useStateValue } from '../utils/Provider/StateProvider';

function DisplayIndividualPerson(props) {
    const [{user}] = useStateValue();
    const [imgURL, setImgURL] = useState("")

    useEffect(() => {
        if(user){
            if(Array.isArray(props.details.details)){
                props.details.details.map(item => (
                    db.collection(user.email)
                    .doc('peoples')
                    .collection('images')
    
                    .onSnapshot(snapshot => {
                        const data = []
                        snapshot.forEach(doc => {
                            
                            let obj = doc.data()
                            if(item.name === obj.name){
                                obj[`${item.name}`] = obj.url
                                obj['uuid'] = doc.id
                                setImgURL(obj)
                            }
    
                        })
                    })
    
                ))
            } else {

                db.collection(user.email)
                    .doc('peoples')
                    .collection('images')
    
                    .onSnapshot(snapshot => {
                        const data = []
                        snapshot.forEach(doc => {
                            
                            let obj = doc.data()
                            if(props.details.details.name === obj.name){
                                obj[`${props.details.details.name}`] = obj.url
                                obj['uuid'] = doc.id
                                setImgURL(obj)
                            }
    
                        })
                    })

            }
        }
        
    }, [])

    
  return (
    <div className='display_person_container modal_background '>
        <div className='display_person_container_content addfamily_modal_container'>
            <div className='addfamily_modal_content_header'>
                <h3 style={{color: 'black'}}>Showing Person Details</h3>
                <i class='fa fa-times' onClick={() => props.handleClose()}></i>
            </div>
            <hr />

            {Array.isArray(props.details.details) ? 
                props.details.details.map(item => (
                    <div className='displaying_person_content_card'>

                        <div className='displaying_person_content_card_row'>
                            <img className='displaying_person_content_card_img' src={imgURL.hasOwnProperty(item.name) ? imgURL[`${item.name}`] : require('../resources/profile_default.png')} alt="" />

                            <div className='displaying_person_content_card_detail'>
                                <p><b>{item.family_name}</b></p>
                                <p><span>Name:</span> <b>{item.name}</b></p>
                                <p><span>Call Him:</span> <b>{item.custom_call_him ? item.custom_call_him : item.call_him}</b></p>
                                <p><span>Married:</span> <b>{item.is_married}</b></p>
                                <p><span>Married With:</span> {item.married_to ? item.married_to : "undefined"}</p>
                                <p><span>Location:</span> {item.location_detail ? item.location_detail : "undefined"}</p>
                                <p><span>Contact:</span> {item.contact_detail ? item.contact_detail : "undefined"}</p>
                                <p><span>Describe:</span> {item.describe_person ? item.describe_person : "undefined"}</p>
                            </div>
                        </div>
                    </div>
                ))
            :
            <div className='displaying_person_content_card'>

                <div className='displaying_person_content_card_row'>
                    <img className='displaying_person_content_card_img' src={imgURL.hasOwnProperty(props.details.details.name) ? imgURL[`${props.details.details.name}`] : require('../resources/profile_default.png')} alt="" />

                    <div className='displaying_person_content_card_detail'>
                        <p><b>{props.details.details.family_name}</b></p>
                        <p><span>Name:</span> <b>{props.details.details.name}</b></p>
                        <p><span>Call Him:</span> <b>{props.details.details.custom_call_him ? props.details.details.custom_call_him : props.details.details.call_him}</b></p>
                        <p><span>Married:</span> <b>{props.details.details.is_married}</b></p>
                        <p><span>Married With:</span> {props.details.details.married_to ? props.details.details.married_to : "undefined"}</p>
                        <p><span>Location:</span> {props.details.details.location_detail ? props.details.details.location_detail : "undefined"}</p>
                        <p><span>Contact:</span> {props.details.details.contact_detail ? props.details.details.contact_detail : "undefined"}</p>
                        <p><span>Describe:</span> {props.details.details.describe_person ? props.details.details.describe_person : "undefined"}</p>
                    </div>
                </div>
            </div>
            }
            
        </div>
    </div>
  )
}

export default DisplayIndividualPerson